import { Flex } from '@digital-retail/design-system';
import { LoginModal } from '@digital-retail/falabella-ui-cross-components';
import {
  SponsoredBrandWrapper,
  SponsoredProductBanner,
  SponsoredProductsContext,
} from '@digital-retail/sponsored-provider-library';
import { isTottusStandalone } from '@digital-retail/store-manager';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useContext, useEffect, useRef, useState } from 'react';
import LazyLoad from 'react-lazyload';
import { ActionBar } from '../../components/ActionBar/ActionBar';
import { resetDigitalData } from '../../components/Facets/Common/digitalData';
import GoogleAdComponent from '../../components/GoogleAds';
import { MediaComponent } from '../../components/Media/MediaComponent';
import MyListAlert from '../../components/MyLists/MyListsAlert/MyListAlert';
import { Pagination } from '../../components/Pagination/Pagination';
import { PaginationDetail } from '../../components/Pagination/PaginationDetail/PaginationDetail';
import Pod from '../../components/Pod/Pod';
import ProductOverlay from '../../components/ProductOverlay/ProductOverlay';
import RecommendedProducts from '../../components/RecommendedProducts/RecommendedProducts';
import { SEOContent } from '../../components/SEOContent/SEOContent';
import { BackgroundOverlay } from '../../components/ui/BackgroundOverlay/BackgroundOverlay';
import { DropdownComponent as Dropdown } from '../../components/ui/Dropdown/Dropdown';
import apiConfig from '../../config/api/apiConfig';
import { constants } from '../../config/constants';
import { track } from '../../external_dependencies/analytic';
import { addToCart as DDAddToCart } from '../../external_dependencies/digitalData/cart';
import { withApplicationContext } from '../../utils/ApplicationContext';
import { withCart } from '../../utils/CartContext';
import { CookieStorage } from '../../utils/CookieStorage';
import { withMyLists } from '../../utils/MyListsContext';
import { ProductContextProvider } from '../../utils/ProductContext';
import {
  navigateWithUrl,
  navigateWithUrlForBrand,
  navigateWithUrlForCategory,
  navigateWithUrlForCollection,
  navigateWithUrlForSeller,
  navigateWithUrlForShop,
} from '../../utils/RouteHandler';
import { SkipSSR } from '../../utils/SkipSSR';
import { withUser } from '../../utils/UserContext';
import { WebStorage } from '../../utils/WebStorage';
import { isWindow } from '../../utils/deviceChecker';
import { useShouldHideSponsoredDisplay } from '../../utils/hooks/UseShouldHideSponsoredPod';
import { useUserSegments } from '../../utils/hooks/useUserSegments';
import { httpService } from '../../utils/httpService';
import { noop } from '../../utils/noop';
import { SearchResultsStyles } from './SearchResults.style';
import {
  getAdInjectorEnabled,
  getFuntionAnalyticsSponsored,
  getHandleBannerActionForSponsorDisplay,
  getHandleBrandActionForSponsoredBrand,
  getInstallmentData,
  getIsSponsoredDisplayEnabled,
  getMaxSponsorBrandCookie,
  getPageId,
  getShouldShowSponsoredBrand,
  handleFetchComplete,
  sendDigitalDataSponsoredProductClick,
} from './utils';

const PodWithoutSSR = SkipSSR(Pod);

const { publicRuntimeConfig } = getConfig();

const SearchResults = ({
  layout,
  products,
  pagination,
  sortOptions,
  appCtx,
  pageName,
  cart,
  setShowFacets,
  setStopScroll,
  refreshUserData,
  collectionId,
  myLists,
  relatedKeywordsUI,
  userSegments,
  isUserLoggedIn,
  leftPromotionContent,
  selectedStore,
}) => {
  const router = useRouter();
  const { tenant, setBusy, deviceType, regionCode, store } = appCtx;
  const labels = appCtx?.siteConfig?.textDictionary ?? {};
  const { MABAYA_TOKEN, MABAYA_EVENTS_ENABLED } = publicRuntimeConfig;
  const id = router?.query?.id || '';
  const Ntt = router?.query?.Ntt || '';
  const name = router?.query?.name || '';
  const providedParamforBanner = getPageId(pageName, router);
  const isMobile = deviceType === 'mobile';

  const ssrPodCountDesktop = appCtx?.siteConfig?.configurations?.xlpSsrOptions?.podCountDesktop ?? 12;
  const ssrPodCountMobile = appCtx?.siteConfig?.configurations?.xlpSsrOptions?.podCountMobile ?? 6;
  const ssrPodCount = isMobile ? ssrPodCountMobile : ssrPodCountDesktop;
  const [productOverlayContext, setProductOverlayContext] = useState({});
  const [isAddToCartInProgress, setIsAddToCartInProgress] = useState(false);
  const [hasAddToCartError, setHasAddToCartError] = useState(false);
  const [isAddToCartSuccessful, setIsAddToCartSuccessful] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [show401Error, setShow401Error] = useState('');
  const [addToCartErrorCode, setAddToCartErrorCode] = useState('');
  const [hasImpressionBeenSentDisplay, setHasImpressionBeenSentDisplay] = useState(false);
  const [hasImpressionBeenSentForBrand, setHasImpressionBeenSentForBrand] = useState(false);
  const [showOverlay, setShowOverlay] = useState(true);
  const { currentUserSegments } = useUserSegments(regionCode, userSegments, isUserLoggedIn, appCtx.store);

  const isSponsoredDisplayEnabled = getIsSponsoredDisplayEnabled(appCtx, Ntt, id);
  const { horizontalProduct } = useContext(SponsoredProductsContext);
  const { addedLists } = myLists || {};
  const catalystBaseUrl =
    appCtx?.header?.entry?.header_configs?.[0]?.links?.catalystbaseurl ?? 'https://www.falabella.com';
  const excludeGscForAddToCart = appCtx?.siteConfig?.textDictionary?.EXCLUDE_GSC_CATEGORY_ID_FOR_ADD_TO_CART ?? '';
  const brandNameRef = useRef(null);

  const SBproductLength = useRef(null);
  const excludeAddToCartGscSet = new Set(excludeGscForAddToCart.split(','));
  const toggleLoginForm = () => {
    cart.setShowLoginForm(!cart.showLoginForm);
  };
  const onClose = () => {
    toggleLoginForm();
  };
  const onUserLogin = () => {
    refreshUserData();
  };
  useEffect(() => {
    const sessionId = WebStorage.getItem({
      name: 'mabayaSession',
      fromPersistence: true,
    });
    if (!(sessionId && sessionId !== 'undefined' && sessionId !== 'false')) {
      const val = window.btoa(Date.now());
      WebStorage.setItem({
        name: 'mabayaSession',
        value: val,
        shouldPersist: true,
      });
    }
    const showImageGalleryTutorial = WebStorage.getItem({
      name: 'showImgGalleryMsg',
      fromPersistence: true,
    });
    setShowOverlay(showImageGalleryTutorial !== 'false');
  }, []);
  const isImageGalleryMsgEnabled = appCtx?.siteConfig?.toggles?.isImageGalleryMsgEnabled ?? false;
  const isImageGalleryEnabled = appCtx?.siteConfig?.toggles?.isImageGalleryEnabled ?? false;
  const isWhiteLabelExperience = appCtx?.siteConfig?.toggles?.isWhiteLabelExperience ?? false;
  const showRecommendedProductsToggle = appCtx?.siteConfig?.toggles?.showRecommendedProducts ?? false;
  const adInjectorIsEnabled = getAdInjectorEnabled(appCtx);

  const handlerSortOption = ({ url }) => {
    setStopScroll(false);
    if (pageName === 'category') {
      navigateWithUrlForCategory({
        site: tenant,
        onRouteChange: () => {
          setBusy(true);
        },
        url,
        categoryId: id,
        categoryName: name,
        store,
        regionCode,
        isWhiteLabelExperience,
      });
    } else if (pageName === 'collection') {
      navigateWithUrlForCollection({
        site: tenant,
        onRouteChange: () => {
          setBusy(true);
        },
        url,
        collectionId: id,
        store,
        regionCode,
        isWhiteLabelExperience,
      });
    } else if (pageName === 'seller') {
      navigateWithUrlForSeller({
        regionCode,
        site: tenant,
        onRouteChange: () => {
          setBusy(true);
        },
        url,
        sellerName: id,
        store,
        isWhiteLabelExperience,
      });
    } else if (pageName === 'brand') {
      navigateWithUrlForBrand({
        regionCode,
        site: tenant,
        onRouteChange: () => {
          setBusy(true);
        },
        url,
        brandName: id,
        store,
        isWhiteLabelExperience,
      });
    } else if (pageName === 'shop') {
      navigateWithUrlForShop({
        site: tenant,
        onRouteChange: () => {
          setBusy(true);
        },
        url,
        store,
        shopId: id,
        regionCode,
        isWhiteLabelExperience,
      });
    } else {
      navigateWithUrl({
        site: tenant,
        onRouteChange: () => {
          setBusy(true);
        },
        url,
        store,
        regionCode,
        isWhiteLabelExperience,
      });
    }
    resetDigitalData();
  };

  const onModalCloseHandler = () => {
    setProductOverlayContext({});
    setHasAddToCartError(false);
    setIsAddToCartSuccessful(false);
    if (deviceType !== 'desktop') {
      setShowFacets(true);
    }
  };

  const setShowModalHandler = (product, selectedVariantId) => {
    setStopScroll(true);
    const productCopy = { ...product, selectedVariantId };
    productCopy.attributes = {
      viewTemplate: product.viewTemplate,
    };
    setProductOverlayContext(productCopy);
    cart.setShowCart(true);
    if (deviceType !== 'desktop') {
      setShowFacets(false);
    }
  };

  const addProductToCart = async (cartContext, product) => {
    setStopScroll(true);
    setShow401Error(false);
    setAddToCartErrorCode('');
    setSelectedProductId(cartContext.productId);
    const productCopy = { ...product };
    productCopy.currentVariant = cartContext;
    productCopy.isSLP = true;
    productCopy.attributes = {
      viewTemplate: product.viewTemplate,
    };

    const params = {};
    params.pgid = appCtx.priceGroupId;
    params.pid = appCtx.politicalId;
    params.zones = encodeURIComponent(appCtx.zones);

    const getProductLiteDetailsUrl = apiConfig.getProductLiteDetailsUrl({
      regionCode: appCtx.regionCode,
      rest: {
        variantId: cartContext.skuId,
        merchantCategoryId: product.merchantCategoryId,
        brandName: product.brand,
        ...params,
      },
    });

    const getProductLiteDetailsUrlPromise = httpService(appCtx).get(getProductLiteDetailsUrl);
    const isInternational = product?.availability?.internationalShipping ?? '';
    const addToCartPromise = cart.addProduct({
      appCtx,
      replaceCartItems: true,
      products: [
        {
          ...cartContext,
          isInternational: !!isInternational,
        },
      ],
      cb: (data) => {
        DDAddToCart(data.cartLines[0], 1);
      },
    });
    setIsAddToCartInProgress(true);
    Promise.all([getProductLiteDetailsUrlPromise, addToCartPromise])
      .then(([productLiteDetails, addToCartErrorResponse]) => {
        const {
          data: { data = {} },
        } = productLiteDetails;
        if (data.stockUnits) {
          productCopy.stockUnits = {};
          data.stockUnits.forEach((stockUnit) => {
            productCopy.stockUnits[stockUnit.variantId] = data.maxOnCartAmount;
          });
          productCopy.maxOnCartAmount = data.maxOnCartAmount;
          productCopy.layoutType = data.layoutType;
          productCopy.guideSymbol = data.guideSymbol;
          setProductOverlayContext({});
          if (!addToCartErrorResponse) {
            track('addToCart');
            setHasAddToCartError(false);
            setIsAddToCartSuccessful(true);
            cart.setShowCart(true);
            setProductOverlayContext(productCopy);
          } else {
            setIsAddToCartSuccessful(false);
            setHasAddToCartError(true);
            cart.setShowCart(true);
            setProductOverlayContext(productCopy);
          }
          setIsAddToCartInProgress(false);
        } else {
          setIsAddToCartInProgress(false);
          setHasAddToCartError(true);
        }
        const errorCode = addToCartErrorResponse?.[0]?.code || '';
        setAddToCartErrorCode(errorCode);
        if (errorCode === constants.ATC_SESSION_EXPIRED_CODE) {
          setShow401Error(true);
        }
        if (deviceType !== 'desktop') {
          setShowFacets(false);
        }
      })
      .catch(() => {
        setAddToCartErrorCode('');
        cart.setShowCart(true);
        setProductOverlayContext(productCopy);
        setIsAddToCartSuccessful(false);
        setHasAddToCartError(true);
        setIsAddToCartInProgress(false);
      });
  };
  const addProductToCartTottus = async (
    cartContext,
    product,
    changeDeliveryType = false,
    cartLineId = '',
    quantityTotal = 1
  ) => {
    setStopScroll(true);
    setShow401Error(false);
    setAddToCartErrorCode('');

    const isInternational = product?.availability?.internationalShipping ?? '';
    const addToCartPromise = cart.addProduct({
      appCtx,
      replaceCartItems: true,
      products: [
        {
          ...cartContext,
          isInternational: !!isInternational,
        },
      ],
      cb: (data) => {
        DDAddToCart(
          data.cartLines.find((item) => item.variantId === product.offeringId),
          1
        );
      },
      changeDeliveryType,
      cartLineId,
      quantityTotal,
    });
    setIsAddToCartInProgress(true);
    addToCartPromise
      .then((addToCartErrorResponse) => {
        if (!addToCartErrorResponse) {
          track('addToCart');
          setHasAddToCartError(false);
          setIsAddToCartSuccessful(true);
          cart.setShowCart(true);
        } else {
          setIsAddToCartSuccessful(false);
          setHasAddToCartError(true);
          cart.setShowCart(true);
        }
        setIsAddToCartInProgress(false);
        const errorCode = addToCartErrorResponse?.[0].code || '';
        setAddToCartErrorCode(errorCode);
        if (errorCode === constants.ATC_SESSION_EXPIRED_CODE) {
          setShow401Error(true);
        }
      })
      .catch(() => {
        cart.setShowCart(true);
        setIsAddToCartSuccessful(false);
        setHasAddToCartError(true);
        setIsAddToCartInProgress(false);
      });
  };

  const sponsoredClick = (productData, order, storeValue) => {
    const isSponsored = productData?.isSponsored ?? false;
    const providerName = productData?.providerName ?? null;
    const adInfo = productData?.mabaya_ad_info ?? productData?.adIdentifier ?? '';
    const sku = productData?.skuId ?? '';

    const isEnabledClickinPDP = appCtx?.siteConfig?.toggles?.isEnabledSponsoredClickInPDP ?? false;

    return (action, isCallFromAddToCart = false) => {
      const isSponsoredService = true; // FEATURE_TOGGLE_SPONSORED_VAS_SERVICE || false;

      const { sponsoredClickService, sponsoredImpressionService, sponsoredVisitService } =
        getFuntionAnalyticsSponsored(isSponsoredService);
      const params = {
        mabayaToken: MABAYA_TOKEN,
        enabled: MABAYA_EVENTS_ENABLED,
        platform: deviceType,
        referrerUrl: window.location.href,
        sku,
        regionCode,
        adInfo,
        mPos: order + 1,
        categoryName: name,
        tenant,
        store: storeValue,
        categoryId: id,
        ...(providerName ? { providerName } : {}),
        productId: productData?.productId,
      };
      const disableSPImpressions = isWindow() ? CookieStorage.getCookie('disableSPImpressions') === 'true' : false;
      const blockedStores = appCtx?.siteConfig?.configurations?.vasConfig?.blockedVisitStores ?? [];
      const shouldSendVisit = !blockedStores.includes(store);
      if (isSponsored) {
        sendDigitalDataSponsoredProductClick(params.mPos, params.sku, isCallFromAddToCart, action === 'click');
        if ((isCallFromAddToCart || !isEnabledClickinPDP) && action === 'click') {
          sponsoredClickService(params);
        }
        if (action === 'impression' && !disableSPImpressions) {
          sponsoredImpressionService(params);
          // eslint-disable-next-line no-underscore-dangle
          if (window && window._satellite) {
            // eslint-disable-next-line no-underscore-dangle
            window._satellite.track('SponsoredProduct_impression', `${sku} | ${order + 1}`);
          }
        }
      }
      if (!isCallFromAddToCart && action === 'visit' && shouldSendVisit) {
        sponsoredVisitService(params, appCtx);
      }
    };
  };

  const handleBannerAction = getHandleBannerActionForSponsorDisplay({
    appCtx,
    config: publicRuntimeConfig,
    categoryName: name,
    categoryId: id,
    mPos: 9,
    hasImpressionBeenSent: hasImpressionBeenSentDisplay,
    setHasImpressionBeenSent: setHasImpressionBeenSentDisplay,
  });

  const handleBrandAction = getHandleBrandActionForSponsoredBrand({
    appCtx,
    config: publicRuntimeConfig,
    categoryName: name,
    categoryId: id,
    hasImpressionBeenSent: hasImpressionBeenSentForBrand,
    setHasImpressionBeenSent: setHasImpressionBeenSentForBrand,
    pageName,
    brandNameRef,
    SBproductLength,
  });
  const handlePodClick = (productData, position, totalProducts) => (setDDXLPOnly) => {
    const productType = productData?.isSponsored ?? false ? 'Sponsored' : 'Normal';
    const pageType = pageName === 'search' ? 'SLP' : 'PLP';
    const multipurposeBadges = (productData?.multipurposeBadges ?? []).map((badge) => badge.label);
    const meatStickers = (productData?.meatStickers ?? []).map((badge) => badge.label);
    const discountBadge = productData?.discountBadge?.label ?? '';
    const installmentsWithoutInterestData = getInstallmentData(productData?.installmentsWithoutInterest ?? []);
    const badges = [...multipurposeBadges, ...meatStickers, installmentsWithoutInterestData];

    if (discountBadge) badges.push(discountBadge);
    const eventToDigitalData = new CustomEvent('DDXLPPodClick', {
      bubbles: true,
      detail: {
        payload: `${position} | ${totalProducts} | ${pageType} | ${productType} | ${badges.join(',') || 'none'}`,
        setDDXLPOnly,
      },
    });
    window.dispatchEvent(eventToDigitalData);
  };

  const isTottusSA = isTottusStandalone(appCtx.store);
  const shouldHideSDForKiosk = useShouldHideSponsoredDisplay(appCtx);
  const sbMaxElements = getMaxSponsorBrandCookie(appCtx);

  const showRecommendedProducts =
    [
      constants.PAGE_NAME.BRAND,
      constants.PAGE_NAME.CATEGORY,
      constants.PAGE_NAME.COLLECTION,
      constants.PAGE_NAME.SEARCH,
    ].includes(pageName) && showRecommendedProductsToggle;
  return (
    <div className="search-results" id="testId-searchResults">
      {Object.keys(productOverlayContext).length > 0 && (
        <ProductContextProvider data={productOverlayContext}>
          <ProductOverlay
            labels={labels}
            onModalCloseHandler={onModalCloseHandler}
            appCtx={appCtx}
            addProductToCart={isTottusSA ? addProductToCartTottus : addProductToCart}
            isAddToCartInProgress={isAddToCartInProgress}
            cart={cart}
            hasAddToCartError={hasAddToCartError}
            isAddToCartSuccessful={isAddToCartSuccessful}
            show401Error={show401Error}
            addToCartErrorCode={addToCartErrorCode}
          />
        </ProductContextProvider>
      )}
      <div className="search-results--actionbar" id="testId-searchResults-actionBar">
        <ActionBar
          left={
            sortOptions.length !== 0 && (
              <Dropdown
                label={labels.ORDER_BY_DESKTOP}
                options={sortOptions}
                tenant={tenant}
                onOptionSelected={handlerSortOption}
                isPrimaryTheme
              />
            )
          }
          right={
            pagination.data.total !== 0 && (
              <Pagination
                pageName={pageName}
                currentPage={pagination.data.currentPage}
                resultsPerPage={pagination.data.perPage}
                totalResults={pagination.data.count >= 9600 ? 9600 : pagination.data.count}
                getPaginatedUrl={pagination.getPaginatedUrl}
                section="top"
                tenant={appCtx.tenant}
                setBusy={appCtx.setBusy}
                setStopScroll={setStopScroll}
                store={store}
              />
            )
          }
        />
      </div>
      <div className="container-my-lists-alert">
        <MyListAlert deviceType={deviceType} addedLists={addedLists} page="xlp" />
      </div>
      <div key={pagination.data.currentPage} className="search-results--products" id="testId-searchResults-products">
        {products.map((product, index) => {
          const productCopy = { ...product };
          const { shouldShowSponsoredBrand, rowNumber } = getShouldShowSponsoredBrand({
            appCtx,
            pageName,
            name,
            deviceType,
            index,
          });
          const { siteConfig } = appCtx;
          const topSortConfig = siteConfig?.configurations?.topSortExperimentConfig ?? {};
          const categoryConfig = new Set(topSortConfig?.categories || []);
          const searchTermConfig = new Set(topSortConfig?.searchTerms || []);
          const isSearchTermInExperiment = searchTermConfig?.has(Ntt);
          const isCategoryInExperiment = categoryConfig?.has(id);
          const hideSB = isCategoryInExperiment || isSearchTermInExperiment;
          if (shouldShowSponsoredBrand && !hideSB) {
            return (
              <>
                <SponsoredBrandWrapper
                  key={pagination.data.currentPage}
                  providedParam={providedParamforBanner}
                  isSearchPage={false}
                  categoryName={name}
                  categoryId={id}
                  onBannerClick={handleBrandAction}
                  maxProducts={sbMaxElements}
                  containerStyle={{
                    margin: '0 0 10px 10px',
                    borderRadius: '12px',
                    color: '#4A4A4A',
                    ...(isMobile ? { marginRight: '10px' } : {}),
                  }}
                  onFetchComplete={(data) => {
                    handleFetchComplete(rowNumber, brandNameRef, SBproductLength)(data);
                  }}
                  id="sponsored-brand-normal-design"
                />
                <SponsoredBrandWrapper
                  key={pagination.data.currentPage}
                  providedParam={providedParamforBanner}
                  isSearchPage={false}
                  categoryName={name}
                  categoryId={id}
                  onBannerClick={handleBrandAction}
                  maxProducts={sbMaxElements}
                  containerStyle={{
                    margin: '0 0 10px 10px',
                    borderRadius: '12px',
                    color: '#4A4A4A',
                    ...(isMobile ? { marginRight: '10px' } : {}),
                    display: 'none',
                  }}
                  onFetchComplete={(data) => {
                    handleFetchComplete(rowNumber, brandNameRef, SBproductLength)(data);
                  }}
                  sbExperimentStyle
                  id="sponsored-brand-experimental-design"
                />
                <div style={{ display: 'none' }} />
                <Pod
                  userSegments={currentUserSegments}
                  layout={layout}
                  product={productCopy}
                  deviceType={deviceType}
                  lazyLoadImage={
                    index >=
                    (deviceType === 'desktop'
                      ? constants.SKIP_LAZY_LOAD_IMAGE_COUNT_DESKTOP
                      : constants.SKIP_LAZY_LOAD_IMAGE_COUNT_MOBILE)
                  }
                  setShowModalHandler={setShowModalHandler}
                  addProductToCart={isTottusSA ? addProductToCartTottus : addProductToCart}
                  isAddToCartInProgress={isAddToCartInProgress}
                  isSelected={selectedProductId === product.productId}
                  labels={labels}
                  sponsoredClick={sponsoredClick(product, index, store)}
                  collectionId={collectionId}
                  handlePodClick={handlePodClick(product, index + 1, products.length)}
                  isFirstPod={index === 0}
                  excludeAddToCartGscSet={excludeAddToCartGscSet}
                  setIsAddToCartInProgress={setIsAddToCartInProgress}
                  index={index}
                  setShowOverlay={setShowOverlay}
                />
              </>
            );
          }

          return index < ssrPodCount ? (
            <Pod
              userSegments={currentUserSegments}
              layout={layout}
              product={productCopy}
              deviceType={deviceType}
              lazyLoadImage={
                index >=
                (deviceType === 'desktop'
                  ? constants.SKIP_LAZY_LOAD_IMAGE_COUNT_DESKTOP
                  : constants.SKIP_LAZY_LOAD_IMAGE_COUNT_MOBILE)
              }
              setShowModalHandler={setShowModalHandler}
              addProductToCart={isTottusSA ? addProductToCartTottus : addProductToCart}
              isAddToCartInProgress={isAddToCartInProgress}
              isSelected={selectedProductId === product.productId}
              labels={labels}
              sponsoredClick={sponsoredClick(product, index, store)}
              collectionId={collectionId}
              handlePodClick={handlePodClick(product, index + 1, products.length)}
              isFirstPod={index === 0}
              excludeAddToCartGscSet={excludeAddToCartGscSet}
              setIsAddToCartInProgress={setIsAddToCartInProgress}
              index={index}
              setShowOverlay={setShowOverlay}
              selectedStore={selectedStore}
            />
          ) : (
            <PodWithoutSSR
              userSegments={currentUserSegments}
              layout={layout}
              product={productCopy}
              deviceType={deviceType}
              lazyLoadImage={
                index >=
                (deviceType === 'desktop'
                  ? constants.SKIP_LAZY_LOAD_IMAGE_COUNT_DESKTOP
                  : constants.SKIP_LAZY_LOAD_IMAGE_COUNT_MOBILE)
              }
              setShowModalHandler={setShowModalHandler}
              addProductToCart={isTottusSA ? addProductToCartTottus : addProductToCart}
              isAddToCartInProgress={isAddToCartInProgress}
              isSelected={selectedProductId === product.productId}
              labels={labels}
              sponsoredClick={sponsoredClick(product, index, store)}
              collectionId={collectionId}
              handlePodClick={handlePodClick(product, index + 1, products.length)}
              isFirstPod={index === 0}
              excludeAddToCartGscSet={excludeAddToCartGscSet}
              setIsAddToCartInProgress={setIsAddToCartInProgress}
              index={index}
              selectedStore={selectedStore}
            />
          );
        })}
      </div>

      {relatedKeywordsUI}
      <div className="search-results--actionbar_bottom" id="testId-searchResults-actionBar-bottom">
        <div className="paginationDetail">
          <MediaComponent from="desktop" to="desktop">
            <PaginationDetail
              totalResults={pagination.data.count}
              resultsPerPage={pagination.data.perPage}
              currentPage={pagination.data.currentPage}
              ofTextLabel={labels.OF}
              resultsTextLabel={labels.RESULTS}
            />
          </MediaComponent>
        </div>

        {pagination.data.total !== 0 && (
          <Flex justifyContent="center">
            <Pagination
              currentPage={pagination.data.currentPage}
              resultsPerPage={pagination.data.perPage}
              totalResults={
                pagination.data.count >= constants.PAGINATION_TOTAL_RESULTS_LIMIT
                  ? constants.PAGINATION_TOTAL_RESULTS_LIMIT
                  : pagination.data.count
              }
              getPaginatedUrl={pagination.getPaginatedUrl}
              section="bottom"
              tenant={appCtx.tenant}
              setBusy={appCtx.setBusy}
              pageName={pageName}
              setStopScroll={setStopScroll}
              store={store}
            />
          </Flex>
        )}
      </div>

      {isSponsoredDisplayEnabled && (
        <div className="bannner-styles">
          {horizontalProduct && !shouldHideSDForKiosk && (
            <SponsoredProductBanner
              onBannerClick={handleBannerAction}
              isVerticalBanner={false}
              product={horizontalProduct}
              store={store}
            />
          )}
        </div>
      )}
      {adInjectorIsEnabled && (
        <div className="google-ad-bottom">
          <GoogleAdComponent adsPosition={constants.GOOGLE_AD_POSITION.BOTTOM} deviceType={!isMobile} />
        </div>
      )}

      {showRecommendedProducts && (
        <div className="recommended-products-container">
          <LazyLoad>
            <RecommendedProducts pageName={pageName} slots="XLP-HRT-1" site="so_com" />
          </LazyLoad>
        </div>
      )}

      <LoginModal
        id="testId-atc-xlp-searchResults"
        catalystBaseUrl={catalystBaseUrl}
        onClose={onClose}
        onUserLogin={onUserLogin}
        tenant={appCtx.regionCode}
        showLoginForm={cart.showLoginForm}
      />
      {isTottusSA && (
        <ProductOverlay
          labels={labels}
          onModalCloseHandler={onModalCloseHandler}
          appCtx={appCtx}
          addProductToCart={addProductToCartTottus}
          isAddToCartInProgress={isAddToCartInProgress}
          cart={cart}
          hasAddToCartError={hasAddToCartError}
          isAddToCartSuccessful={isAddToCartSuccessful}
          show401Error={show401Error}
          addToCartErrorCode={addToCartErrorCode}
        />
      )}
      <SEOContent html={leftPromotionContent} deviceType={appCtx.deviceType} />
      <style jsx>{SearchResultsStyles}</style>
      {deviceType !== 'desktop' && isImageGalleryEnabled && isImageGalleryMsgEnabled && showOverlay && (
        <BackgroundOverlay />
      )}
    </div>
  );
};

SearchResults.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object),
  sortOptions: PropTypes.array.isRequired,
  pagination: PropTypes.shape({
    data: PropTypes.object,
    onPageSelection: PropTypes.func,
    getPaginatedUrl: PropTypes.func,
  }).isRequired,
  appCtx: PropTypes.object.isRequired,
  layout: PropTypes.object,
  pageName: PropTypes.string,
  cart: PropTypes.object.isRequired,
  setShowFacets: PropTypes.func.isRequired,
  refreshUserData: PropTypes.func.isRequired,
  setStopScroll: PropTypes.func,
  collectionId: PropTypes.string,
  myLists: PropTypes.object.isRequired,
  relatedKeywordsUI: PropTypes.object,
  userSegments: PropTypes.array,
  isUserLoggedIn: PropTypes.bool,
  leftPromotionContent: '',
  selectedStore: PropTypes.string,
};

SearchResults.defaultProps = {
  products: [],
  layout: {
    desktop: {
      view: '4_GRID',
    },
    mobile: {
      view: '2_GRID',
    },
  },
  pageName: 'search',
  setStopScroll: noop,
  collectionId: '',
  relatedKeywordsUI: null,
  userSegments: [],
  isUserLoggedIn: false,
  leftPromotionContent: PropTypes.string,
  selectedStore: undefined,
};

export default withApplicationContext(withUser(withCart(withMyLists(SearchResults))));
export { SearchResults };
